var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('terms-dialog', {
    on: {
      "isLoaded": _vm.setTermsList,
      "input": function input(value) {
        return _vm.$emit('input', value);
      },
      "isValid": function isValid(_isValid) {
        return _vm.$emit('isValid', _isValid);
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('v-sheet', _vm._g({
          attrs: {
            "color": "mt-20 mt-lg-42"
          }
        }, on), [_c('v-checkbox', {
          staticClass: "mb-12",
          attrs: {
            "label": "전체 동의하기",
            "hide-details": "",
            "color": "primary",
            "readonly": ""
          },
          model: {
            value: _vm.isAllSelected,
            callback: function callback($$v) {
              _vm.isAllSelected = $$v;
            },
            expression: "isAllSelected"
          }
        }), _c('v-card', {
          staticClass: "min-h-80px",
          attrs: {
            "outlined": "",
            "rounded": "lg"
          }
        }, [_c('div', {
          staticClass: "pa-12 pa-md-20"
        }, [_vm._l(_vm.items, function (item) {
          return [_c('v-checkbox', _vm._b({
            key: item._id,
            attrs: {
              "hide-details": "",
              "readonly": ""
            },
            model: {
              value: item.value,
              callback: function callback($$v) {
                _vm.$set(item, "value", $$v);
              },
              expression: "item.value"
            }
          }, 'v-checkbox', item, false))];
        })], 2)])], 1)];
      }
    }]),
    model: {
      value: _vm.selected,
      callback: function callback($$v) {
        _vm.selected = $$v;
      },
      expression: "selected"
    }
  });
}
var staticRenderFns = []

export { render, staticRenderFns }